export const SRResponse_uischema = (caseNumber, internalStatus = "") => {
  const docCategoryResolver = () => {
    switch (internalStatus?.toUpperCase()) {
      // RFI Response
      case "PENDING NSR - RFI ISSUED":
      case "PENDING DAIL - RFI ISSUED":
      case "PENDING DRAFT AD - RFI ISSUED":
      case "PENDING AD PLACEMENT - RFI ISSUED":
      case "ACTIVE RECRUITMENT - RFI ISSUED":
      case "PENDING RECRUITMENT REPORT - RFI ISSUED":
        return "RFI Response";
      // DAIL Response (future filers)
      case "PENDING DAIL - DRAFT AD":
        return "DAIL Response";
      // NSR Response (non future filers)
      case "PENDING NSR - DRAFT AD":
        return "NSR Response";
      // RIL Response
      case "PENDING AD PLACEMENT":
        return "RIL Response";
      // Applicant Resumes
      case "ACTIVE RECRUITMENT":
        return "Applicant Resumes";
      default:
        return "SR Response";
    }
  };

  const fileTypeFieldResolver = () => {
    switch (internalStatus?.toUpperCase()) {
      case "PENDING RRIL DECISION - RFI ISSUED - EXTENSION REQUESTED":
      case "PENDING RRIL DECISION - RFI ISSUED":
      case "PENDING RRIL DECISION - ASSIGNED":
        return {
          machine_name: "fileType",
          widget: "select",
          label: "Document Category",
          selection: [
            "Advertising Documents",
            "Applications of applicants who applied directly to employer",
            "Applicant Resumes",
            "Employment Application / Pre-screening tools",
            "Job Order",
            "Notice of Filing",
            "Newspaper Advertisements",
            "Other Supporting Documentation",
            "Recruitment Report",
          ],
          validate: ["required"],
        };
      default:
        return {
          machine_name: "fileType",
          value: docCategoryResolver(internalStatus),
          widget: "text",
          style: {
            display: "none",
          },
        };
    }
  };

  return {
    name: "SR Response",
    pageInfo: {
      text: "Use this form to upload documents to your submitted application. Uploaded documents will be added to case documents. Please check the correspondence issued for details on what is required for your case.",
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          fileTypeFieldResolver(),
          {
            machine_name: "SR_Response_Case_Number",
            widget: "text",
            label: "Case Number *",
            maxLength: 100,
            disabled: true,
            value: caseNumber || "",
          },
          {
            machine_name: "files",
            widget: "file_upload",
            file_upload: { fileType: "SR_Response_Document_Upload" },
            accept_multiple: true,
            required: true,
            validate: ["required", "file_required"],
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
          },
        ],
      },
    ],
  };
};
